// Импортируем все перенесенные компоненты
import AoIcon from './components/AoIcon.vue'
import AoBtn from './components/AoBtn.vue'
import AoIconBtn from './components/AoIconBtn.vue'
import AoAvatar from './components/AoAvatar.vue'
import AoChip from './components/AoChip.vue'
import AoChipGroup from './components/AoChipGroup.vue'

import AoGreatSelect from './components/aoGreatSelect/AoGreatSelect.vue'
import AoSelectItem from './components/AoSelectItem.vue'
import AoTextField from './components/AoTextField.vue'
import AoButtonToggle from './components/AoButtonToggle.vue'
import AoCheckbox from './components/AoCheckbox.vue'

import AoBottomSheet from './components/AoBottomSheet.vue'
import AoPreloader from './components/AoPreloader.vue'
import AoBadgeStatus from './components/AoBadgeStatus.vue'
import AoInfoBanner from './components/AoInfoBanner.vue'
import AoListItem from './components/AoListItem.vue'
import AoFloatingActionPanel from './components/aoFloatingActionPanel/AoFloatingActionPanel.vue'

// Собираем их в объект для удобства регистрации
const components = {
	AoIcon,
	AoBtn,
	AoIconBtn,
	AoAvatar,
	AoChip,
	AoChipGroup,

	AoSelect: AoGreatSelect,
	AoSelectItem,
	AoTextField,
	AoButtonToggle,
	AoCheckbox,

	AoBottomSheet,
	AoInfoBanner,
	AoPreloader,
	AoBadgeStatus,
	AoListItem,
	AoFloatingActionPanel,
}

// Экспортируем функцию-установщик
export function install(app) {
	for (const componentName in components) {
		const component = components[componentName]
		app.component(componentName, component)
	}
}
